export default __webpack_public_path__ + "static/section4_feature3-c384b745c334dab68b2c33626a2b9128.png";